import { ComponentId, Layout, LayoutOptions, OmegaComponent, Overlay, dom } from "@omegagrid/core";
import { Application } from "./container/application";

export class StateEvent extends Event {
	constructor(type: string, public readonly component: AppComponent) {
		super(type, {bubbles: true, composed: true});
	}
}

export type ComponentState = {
	name?: string;
	[key: string]: unknown;
}

export abstract class AppComponent<
	TApp extends Application = Application,
	TState extends ComponentState = ComponentState
> extends OmegaComponent<TState> implements Layout {

	private _app: TApp;
	get app() { return this._app }
	set app (app: TApp) { this._app = app }

	componentId: ComponentId;
	name: string;
	
	get host() { return this.app?.host }
	get container() { return this.app?.container }
	get router() { return this.app?.router }

	createComponentId(...segments: (string|number)[]) {
		return `${this.app.name}-${segments.join('-')}`;
	}

	private _loader: Overlay;

	showLoader() {
		this._loader ??= dom.createElement('og-overlay', {defaultLoader: true});
		dom.setPosition(this._loader, {t: 0, l: 0, r: 0, b: 0});
		dom.showElement(this._loader);
		this.style.position = 'relative';
		this.shadowRoot.prepend(this._loader);
	}

	hideLoader() {
		this._loader?.remove();
	}

	layout(options?: LayoutOptions) { };

}
